import React from "react";
import _ from "lodash";
import { dater, dt_dater } from "../../helpers";
import { DateTime } from "luxon";

// ============================ ACC ==============================
export function getHotelBasicData({ reservation, t }) {
  if (!reservation) return [];

  return [
    [t("hotelName"), reservation?.accommodation_meta?.name ?? ""],
    [t("reference"), reservation.reference],
    [t("checkIn"), dater(reservation.check_in)],
    [t("checkOut"), dater(reservation.check_out)],
    [
      t("reservationDate"),
      DateTime.fromISO(reservation.created).toLocaleString(
        DateTime.DATETIME_SHORT
      ),
    ],
    [
      t("status"),
      reservation.status === "CO"
        ? t("confirmed")
        : reservation.status === "CA"
        ? t("cancelled")
        : reservation.status === "FA"
        ? t("notConfirmed")
        : t("pending"),
    ],
  ];
}

export function getHotelExtraData({ reservation, t }) {
  if (!reservation) return [];

  const output = [
    [
      t("freeCancellationAvailable"),
      reservation.non_refundable ? t("no") : t("yes"),
    ],
  ];

  const extraOutput = [
    [
      t("freeCancellationDeadline"),
      dt_dater(reservation.max_cancellation_date),
    ],
  ];
  return reservation.non_refundable ? output : [...output, ...extraOutput];
}

export function getHotelPax({ reservation, t }) {
  if (!reservation) return [];

  return _.get(reservation, "guests", []).map((guest) => [
    [t("type"), guest.guest_type_display],
    [t("title"), guest.guest_title_display],
    [t("firstName"), guest.first_name],
    [t("lastName"), guest.last_name],
    [t("email"), guest.email],
    ["leadGuest", guest.group_leader ? <strong>{t("yes")}</strong> : ""],
  ]);
}
